export const formatPenceToPounds = (pence: number | null | undefined): string => {
  if (pence === null || pence === undefined) return '-';
  return `£${(pence / 100).toFixed(2)}`;
};

export const getBillingTypeLabel = (
  billingType: 'FIXED' | 'PER_UNIT' | null | undefined,
): string => {
  if (!billingType) return '-';
  switch (billingType) {
    case 'FIXED':
      return 'Fixed';
    case 'PER_UNIT':
      return 'Per unit';
    default:
      return billingType;
  }
};
